
import './ccf-unavailable-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfUnavailableIconProps extends SvgIconProps  {}
/**
 * This icon will be used to display unavailable status of agent
 * @param props - CcfUnavailableIconProps
 * @example - <CcfUnavailableIcon />
 * @returns SVG of unavailable icon
 */
export function CcfUnavailableIcon(props: CcfUnavailableIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_busy" clipPath="url(#clip-ic_busy)">
        <g
          id="Group_119864"
          data-name="Group 119864"
          transform="translate(-884 -50)"
        >
          <circle
            id="Ellipse_4745"
            data-name="Ellipse 4745"
            cx="8.5"
            cy="8.5"
            r="8.5"
            transform="translate(888 54)"
            fill="#c4314b"
          />
          <path
            id="Path_25132"
            data-name="Path 25132"
            d="M890.557,62.209h10"
            transform="translate(0.943 0.291)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfUnavailableIcon;
